export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_01.47ccdcde.jpg";